import React from 'react';

import { useQuery } from '@apollo/react-hooks';
import { RouteComponentProps } from 'react-router-dom';
import useReactRouter from 'use-react-router';
import copy from '../copy';
import useDocumentTitle from '../hooks/use-document-title';

import Button from '@do/walrus/Button';
import Text from '@do/walrus/Text';
import Background from './Background';
import { FormWrap, Loading, PaddedContents, Wrap } from './Common';
import Header from './Header';
import PasswordResetForm from './PasswordResetForm';

import { ResetPasswordFormGqlData } from '../interfaces/login';
import { GET_PASSWORD_RESET_FORM_DATA } from '../queries/queries';

import defaultBg from '../assets/backgrounds/Login_Default.jpg';

function PasswordReset({ location }: RouteComponentProps) {
  const token = location.pathname.split('/').pop() || '';
  const { loading, error } = useQuery<ResetPasswordFormGqlData>(
    GET_PASSWORD_RESET_FORM_DATA,
    {
      variables: {
        token
      }
    }
  );

  const { history } = useReactRouter();
  useDocumentTitle(copy.form.password_reset_title);

  if (loading) {
    return <Loading isLogin={true} />;
  }

  return (
    <>
      <Header isLogin={true} />
      <Wrap>
        <Background url={defaultBg} />
        <FormWrap>
          <PaddedContents>
            <h4>
              {!error
                ? copy.form.password_reset.title
                : copy.form.password_reset.error_title}
            </h4>
            <Text>
              {!error
                ? copy.form.password_reset.details
                : copy.form.password_reset.error_details}
            </Text>
            {!error ? (
              <PasswordResetForm token={token} />
            ) : (
              <Button
                onClick={() => history.push('/forgot_password/new')}
                fullWidth
              >
                {copy.form.password_reset.button_text}
              </Button>
            )}
          </PaddedContents>
        </FormWrap>
      </Wrap>
    </>
  );
}

export default PasswordReset;
